import React, { useEffect, useState, Fragment } from 'react';
import $ from "jquery";

import MapChartDirect from './charts/MapChartDirect';

import images from '../../style/img/flag/images';

import { getIndicatorCountries, getMapTableData } from '../../api';

const MapSection = props => {

    const [countries, setCountries] = useState([]);
    const [openSelectCountries, setOpenSelectCountries] = useState(false);
    const [tableData, setTableData] = useState(null);
    const [filters, setFilters] = useState({
        countries: [],
        selectedIndicator: props.selectedIndicator.id
    });

    useEffect(() => {
        loadData();
        window.addEventListener('scroll', stickyCountry);
    }, [])

    const loadData = () =>
    {
        getMapTableData(props.chartID)
        .then((res) => {
            setTableData(res.resultset);
        })

        getIndicatorCountries([props.chartID])
        .then((res) => {
            // The query will not return EU27_2020, add it if necessary
            let countries = [];
            if (props.showEUBanner == true)
            {
                countries = [ { code:"EU27_2020",literalID:822,name:"EU27_2020" } ]
            }
            countries = countries.concat(res.resultset);
            setCountries(countries);
        })
    }

    const handleIndicatorChange = (e) =>
    {
        const option = e.target.value;
        setFilters( {...filters, selectedIndicator: option } );
    }

    const handleCountryClick = (country) =>
    {
        // Check if the country is already selected in the filters
        let index = filters.countries.indexOf(country);
        if (index != -1)
        {
            // The country has been already filtered, remove it from the filters
            let filterCountries = filters.countries;
            filterCountries.splice(index, 1);
            setFilters( {...filters, countries: filterCountries } );
        }
        else
        {
            // Add the country to the filters
            setFilters( {...filters, countries: filters.countries.concat([country] ) } );
        }
    }

    const handleMapClick = (countryCode) => 
    {
        // Search for the country in the list of countries
        const country = countries.filter(country => country.code == countryCode)[0]
        // Set the country as the selected one
        setFilters( {...filters, countries: [country] } );
    }

    const clearCountryFilter = () =>
    {
        setFilters( {...filters, countries: [] } );
    }

    const onSelectCountryTag = (countryCode) => 
    {
        const country = countries.filter(country => country.code == countryCode)[0]
        handleCountryClick(country);
    }

    const openSelect = () =>
    {   
        setOpenSelectCountries(!openSelectCountries);
    }

    const bannerForCountry = (countryCode, isEU, isBanner) =>
    {
        let result = null;
        if (tableData != null)
        {
            const countryData = tableData.filter(country => country.countryCode == countryCode)[0];
            let header = <div className="matrix--header--elements">
                <img className="flags--wrapper" src={ images[countryCode.toLowerCase()] } />
                <h2 className="country title-section main-color">{ countryData.countryName }</h2>
            </div>

            let content = <ul className="matrix--elements--data">
                { props.indicatorList.map((indicator, index) =>
                    <li key={index}>
                        <label>{ props.literals[`L${indicator.literalId}`] }</label>
                        <div><span className="data">{ countryData.data[indicator.id] != null ? countryData.data[indicator.id] : '-' }</span></div>
                    </li>
                )}
            </ul>

            result = <div key={ countryCode } className={isBanner ? "map--legend--block map--countries--legend container" : `matrix--element ${ countryCode.toLowerCase() }`}>
                { header } 
                { content }
                {isBanner && !isEU ? <span className="close-legend" onClick={() => clearCountryFilter()}><i className="fa fa-times" ></i></span> : ''}
            </div>;
        }
        return result;
    }

    const stickyCountry = () =>
    {   
        let element = $( ".survey--map--block" );
		
		let offset = element.offset();     
		if($(window).scrollTop() >= offset.top){
			$( ".survey--map--block" ).addClass('fixed');
		} else {
			$( ".survey--map--block" ).removeClass('fixed');
		}
    }

    const selectedIndicator = props.indicatorList.find((indicator) => indicator.id == filters.selectedIndicator);
    const mapTitle = selectedIndicator != undefined ? props.literals[`L${selectedIndicator.literalId}`] : '';
    let dataForMobileCountries = countries;
    if (filters.countries.length > 0)
    {
        dataForMobileCountries = filters.countries;
    }
    
    return (
        <Fragment>
            <div className="filter--indicator--block container">
                <ul className="indicators--group xs-row">
                    {/* Filter for changing the indicator in desktop */}
                    <li id="filter1">
                        <label htmlFor="indicatorSelect">{ props.literals.L20623 }</label> 

                        <select onChange={ handleIndicatorChange } id="indicatorSelect" className="filter--dropdown--list" value={ filters.selectedIndicator }>
                            { props.indicatorList.map((indicator, index) => 
                                <option key={ index } value={indicator.id}>{ props.literals[`L${indicator.literalId}`] }</option>
                            )}
                        </select>
                    </li>

                    {/* Filter for changing the country (only on < 1024px) */}
                    <li id="filter2" className={`filter--dropdown--wrapper ${ openSelectCountries ? 'viewOptions' : ''} `}>
                        <label>{ props.literals.L20630 }</label> 
                        <div className="filter--dropdown--list">
                            <p className="option-title" onClick={ openSelect }>{ props.literals.L20630 }</p>
                            {<ul className="filter--dropdown--options">
                                { countries.map((country) => (
                                    <li key={country.code} onClick={() => handleCountryClick(country)}>
                                        <input type="checkbox" checked={ filters.countries.find((countryFilters) => countryFilters.code == country.code) ? true : false} readOnly />
                                        <label>{ country.code == 'EU27_2020' ? '' : `(${country.code})` } {country.name}</label>
                                    </li>
                                ))}
                            </ul>}
                        </div>
                    </li>
                </ul>
            </div>
            <div className="line background-main-light"></div>
            <section className="container container-full nopadding">
                <section className="survey--map--block">
                    <div className="sticky--wraper">
                        {
                            (props.showEUBanner === true) && 
                            <div className="legend--block eu">
                                { bannerForCountry('EU27_2020', true, true) }
                            </div>
                        }                            

                        <div className="legend--block">
                            {
                                filters.countries.length == 1 ? bannerForCountry(filters.countries[0].code, false, true) : 
                                    <div>
                                        <p className="help-text container"><strong>Click on a country to compare</strong> the data <span className="exclamation" aria-hidden="true"></span></p> 
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="map--block center-text container">				
                        <MapChartDirect 
                            chartID = { props.chartID }
                            indicatorID = { filters.selectedIndicator }
                            handleMapClick = { handleMapClick }
                            selectedCountry = { filters.countries }
                            title = { mapTitle }
                        />
                    </div>
                    { selectedIndicator.footNote && (
                        <div className="center-text">
                            <p>{ props.literals[`L${ selectedIndicator.footNote }`] }</p>
                        </div>
                    )}
                </section>
                <section className="survey--map--block-mobile">
                    <div className="selected--tags-wrapper">
                        { filters && (
                            <div>
                                { filters.countries.map((country) => (
                                    <span key={country.code} className="selected-tag" onClick={() => this.onSelectCountryTag(country.code)}>{country.code == 'EU27_2020' ? '' : `${country.code}`} {country.name}</span>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="matrix--elements--wrapper">
                        <div>
                            { dataForMobileCountries.map((country, index) => (
                                bannerForCountry(country.code, country.code=='EU27_2020', false)
                            )) }
                        </div>
                    </div>
                </section>
            </section>
        </Fragment>            
    );
}

export default MapSection;